/**
 * Customer-facing bestek texts shared by the customer page (BestekCard) and
 * the PDF, so both show the same information. Keys are the CMS suffixes under
 * `frontend.my.repairs.bestek.`; the CMS value wins, these are the Dutch
 * defaults (keep in sync with Docs/generate-bestek-content.js).
 */
const BESTEK_CUSTOMER_COPY_KEY_PREFIX = "frontend.my.repairs.bestek.";

const BESTEK_CUSTOMER_COPY_NL = {
  "route.repair.title": "Herstellen",
  "route.repair.subtitle":
    "Toestel laten herstellen.\nVerplichte werkzaamheden eerst, daarna optioneel.",
  "route.repair.estimate-min": "min.",
  "route.repair.estimate-max": "max.",
  "route.repair.estimate-range-hint":
    "Minimum: diagnose + verplichte werkzaamheden. Maximum: als u ook alle optionele werkzaamheden laat uitvoeren.",
  "route.cost-note":
    "U betaalt nooit beide. Bij herstellen betaalt u de reeds uitgevoerde diagnose en de herstelling, zonder behandelingskost. Bij niet herstellen betaalt u enkel de behandelingskost (of een vervangartikel, dan vervalt ook die).",
  "route.no-repair.title": "Niet herstellen",
  "route.no-repair.subtitle-with-products":
    "Geen herstel.\nBehandelingskost of vervangartikel (zonder behandelingskost).",
  "route.no-repair.subtitle-without-products":
    "Geen herstel.\nU betaalt enkel de behandelingskost.",
  "no-repair.what-to-do": "Wat wilt u doen?",
  "no-repair.new-product": "Nieuw product:",
  "no-repair.indicative-price": "Richtprijs onder voorbehoud:",
  "no-repair.no-handling-fee": "(geen behandelingskost)",
  "no-repair.your-advantage": "Uw voordeel:",
  "options.title": "Herstelopties",
  "disposition.title": "Wat met uw toestel?",
  "disposition.return": "Terug sturen",
  "disposition.pickup": "Zelf afhalen",
  "disposition.keep": "Niet terug sturen",
  "disposition.return-disclaimer":
    "Bij terugsturen: toestel wordt as-is (gedemonteerd) teruggezonden. Transportkosten worden in rekening gebracht.",
  "disposition.pickup-disclaimer":
    "Bij afhalen: u haalt het toestel as-is (gedemonteerd) zelf af bij Welda. Er worden geen transportkosten aangerekend.",
  "keep-old": "Oud toestel behouden",
  "payment.immediate-notice":
    "Uw betalingsvoorwaarde is contant / voorafbetaling. Afhankelijk van de situatie laten wij u weten of u vooraf betaalt of bij afhaling.",
  "cart.handling-fee": "Behandelingskost",
  "cart.diagnosis": "Diagnose",
  "cart.diagnosis-executed": "Reeds uitgevoerd",
  "action.execute": "Uitvoeren",
  "action.skip-execute": "Niet uitvoeren",
  "cost.labor": "Werkuren",
  "cost.repair-materials": "Reparatiematerialen",
  "cost.replacement-materials": "Vervangonderdelen",
  "cost.total": "Totaal",
  "fallback.must-work": "Verplichte werkzaamheden",
  "confirm.customer-reference": "Uw referentie (PO)",
  "price.excl-btw": "excl BTW",
  "requirement.must": "Vereist",
  "requirement.advised": "Geadviseerd",
  "requirement.optional": "Mogelijk",
  "requirement.must-desc":
    "Herstelwerkzaamheden welke de werking van het toestel beïnvloeden",
  "requirement.advised-desc":
    "Herstelwerkzaamheden welke de conformiteit of veiligheid van het toestel beïnvloeden",
  "requirement.optional-desc":
    "Herstelwerkzaamheden welke kunnen worden aanzien als algemeen onderhoud",
};

/** "min. € 610,16 – max. € 710,16" with the labels next to the amounts. */
const formatBestekEstimateRange = (min, max, copy = BESTEK_CUSTOMER_COPY_NL) =>
  `${copy["route.repair.estimate-min"]} ${min} – ${copy["route.repair.estimate-max"]} ${max}`;

module.exports = {
  BESTEK_CUSTOMER_COPY_KEY_PREFIX,
  BESTEK_CUSTOMER_COPY_NL,
  formatBestekEstimateRange,
};
